import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    // mode: 'history',
    cache: false,
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/404',
            name: 'NotFound',
            meta: {
                title: '404'
            },
            component: () => import('./views/404/index.vue')
        },
        {
            path: '/',
            redirect: '/home/:did',
            meta: {
                title: '首页'
            },
            // component: () => import('./views/empower/cyjjj.vue')
        },
        {
            path: '/home/:did',
            name: '/home',
            meta: {
                title: '首页'
            },
            component: () => import('./views/home/home.vue')
        },
        {
            path: '/category/:did',
            name: '/category',
            meta: {
                title: '分类'
            },
            component: () => import('./views/category/index.vue')
        },
        {
            path: '/quanyi/:did',
            name: '/quanyi',
            meta: {
                title: '权益'
            },
            component: () => import('./views/quanyi/index.vue')
        },
        {
            path: '/cart/:did',
            name: '/cart',
            meta: {
                title: '购物车'
            },
            component: () => import('./views/cart/index.vue')
        },
        {
            path: '/my/:did',
            name: '/my',
            meta: {
                title: '我的'
            },
            component: () => import('./views/my/index.vue')
        },
        {
            path: '/wxcode/:did',
            name: '/wxcode',
            meta: {
                title: '公众号二维码'
            },
            component: () => import('./views/my/wxcode.vue')
        },
        {
            path: '/ptcats/:did/:catId',
            name: '/ptcats',
            meta: {
                title: '普通商品二级分类'
            },
            component: () => import('./views/cats/ptcats.vue')
        },
        {
            path: '/msList/:did',
            name: '/msList',
            meta: {
                title: '秒杀商品'
            },
            component: () => import('./views/cats/msList.vue')
        },
        {
            path: '/empower/:did',
            name: '/empower',
            meta: {
                title: '授权'
            },
            component: () => import('./views/empower/index.vue')
        },
        {
            path: '/invite/:did/:mid',
            name: '/invite',
            meta: {
                title: '邀请授权'
            },
            component: () => import('./views/empower/invite.vue')
        },
        {
            path: '/qkk/:did/:mid/:mmrid',
            name: '/qkk',
            meta: {
                title: '请客卡分享'
            },
            component: () => import('./views/share/qkk.vue')
        },
        {
            path: '/login/:did/:deptName',
            name: '/login',
            meta: {
                title: '登录'
            },
            component: () => import('./views/login/login.vue')
        },
        {
            path: '/myOrder/:did/:active',
            name: 'myOrder',
            meta: {
                title: '我的订单'
            },
            component: () => import('./views/order/myOrder.vue')
        },
        {
            path: '/ztOrder/:did/:active',
            name: 'ztOrder',
            meta: {
                title: '自提订单'
            },
            component: () => import('./views/order/ztOrder.vue')
        },

        {
            path: '/spuDetails/:did/:spuId',
            name: '/spuDetails',
            meta: {
                title: '商品详情',
            },
            component: () => import('./views/spu/details.vue')
        },
        {
            path: '/fxSpuDetails/:did/:mid/:spuId',
            name: '/fxSpuDetails',
            meta: {
                title: '分享商品详情',
            },
            component: () => import('./views/share/details.vue')
        },

        {
            path: '/msDetails/:did/:spuId',
            name: '/msDetails',
            meta: {
                title: '秒杀商品详情',
            },
            component: () => import('./views/spu/msDetails.vue')
        },
        {
            path: '/fxmsDetails/:did/:mid/:spuId',
            name: '/fxmsDetails',
            meta: {
                title: '分享秒杀商品详情',
            },
            component: () => import('./views/share/msDetails.vue')
        },
        {
            path: '/plusDetails/:did/:plusId',
            name: '/plusDetails',
            meta: {
                title: 'PLUS商品详情'
            },
            component: () => import('./views/spu/pulsDetails.vue')
        },
        {
            path: '/fxplusDetails/:did/:mid/:plusId',
            name: '/fxplusDetails',
            meta: {
                title: 'PLUS商品详情'
            },
            component: () => import('./views/share/pulsDetails.vue')
        },
        {
            path: '/orderDetails/:did/:orderId',
            name: '/orderDetails',
            meta: {
                title: '快递单品订单详情',
            },
            component: () => import('./views/order/details.vue')
        },

        {
            path: '/orderGoodsDetails/:did/:orderId',
            name: '/orderGoodsDetails',
            meta: {
                title: '快递多品订单详情',
            },
            component: () => import('./views/order/goodsDetails.vue')
        },

        {
            path: '/ztptDetails/:did/:orderId',
            name: '/ztptDetails',
            meta: {
                title: '自提单品订单详情',
            },
            component: () => import('./views/order/ztptDetails.vue')
        },

        {
            path: '/ztGoodsDetails/:did/:orderId',
            name: '/ztGoodsDetails',
            meta: {
                title: '自提多品订单详情页',
            },
            component: () => import('./views/order/ztGoodsDetails.vue')
        },
        {
            path: '/wallet/:did',
            name: '/wallet',
            meta: {
                title: '我的钱包',
            },
            component: () => import('./views/my/wallet.vue')
        },
        {
            path: '/give/:did',
            name: '/give',
            meta: {
                title: '请客赠送',
            },
            component: () => import('./views/my/give.vue')
        },
        {
            path: '/revenueDetails/:did',
            name: '/revenueDetails',
            meta: {
                title: '收入明细',
            },
            component: () => import('./views/my/revenueDetails.vue')
        },
        {
            path: '/mydata/:did',
            name: '/mydata',
            meta: {
                title: '我的数据',
            },
            component: () => import('./views/my/mydata.vue')
        },
        {
            path: '/address/:did',
            name: '/address',
            meta: {
                title: '地址',
            },
            component: () => import('./views/address/index.vue')
        },
        {
            path: '/editAddress/:did/:adsId',
            name: '/editAddress',
            meta: {
                title: '编辑地址',
            },
            component: () => import('./views/address/edit.vue')
        },
        {
            path: '/addAddress/:did',
            name: '/addAddress',
            meta: {
                title: '编辑地址',
            },
            component: () => import('./views/address/add.vue')
        },
        {
            path: '/buy/:did/:skuId/:skuNum',
            name: '/buy',
            meta: {
                title: '单品填写订单',
            },
            component: () => import('./views/order/buy.vue')
        },
        {
            path: '/buyCart/:did',
            name: '/buyCart',
            meta: {
                title: '购物填写订单',
            },
            component: () => import('./views/order/buyCart.vue')
        },
        {
            path: '/buyGoods/:did/:no/:type/:goodsId',
            name: '/buyGoods',
            meta: {
                title: '多商品填写订单',
            },
            component: () => import('./views/order/buyGoods.vue')
        },
        {
            path: '/buyMs/:did/:no/:type/:goodsId',
            name: '/buyMs',
            meta: {
                title: '秒杀商品填写订单',
            },
            component: () => import('./views/order/buyMs.vue')
        },
        {
            path: '/editInfo/:did/:code',
            name: '/editInfo',
            meta: {
                title: '绑定用户信息'
            },
            component: () => import('./views/member/edit.vue')
        },
        {
            path: '/yqEditInfo/:did/:mid/:code',
            name: '/yqEditInfo',
            meta: {
                title: '邀请绑定用户信息'
            },
            component: () => import('./views/member/yqEdit.vue')
        },
        {
            path: '/mbinfo/:did',
            name: '/mbinfo',
            meta: {
                title: '商城用户信息'
            },
            component: () => import('./views/my/mbinfo.vue')
        },
        {
            path: '/updateMember/:did/:mid/:type/:val',
            name: '/updateMember',
            meta: {
                title: '更新用户信息'
            },
            component: () => import('./views/my/updateMember.vue')
        },
        {
            path: '/success/:did/:type',
            name: '/success',
            meta: {
                title: '支付结果'
            },
            component: () => import('./views/success/index.vue')
        },
        {
            path: '/share/:did',
            name: '/share',
            meta: {
                title: '分享页面',
            },
            component: () => import('./views/share/details.vue')
        },
        {
            path: '/myCards/:did',
            name: 'myCards',
            meta: {
                title: '我的会员卡'
            },
            component: () => import('./views/my/myCards.vue')
        },
        {
            path: '/myMdTc/:did',
            name: 'myMdTc',
            meta: {
                title: '套餐管理'
            },
            component: () => import('./views/my/myMdTc.vue')
        },
        {
            path: '/myMdCmp/:did',
            name: 'myMdCmp',
            meta: {
                title: '消费记录'
            },
            component: () => import('./views/my/myMdCmp.vue')
        },
        {
            path: '/empsq/:did/:empId',
            name: 'empsq',
            meta: {
                title: '员工授权'
            },
            component: () => import('./views/empower/emp.vue')
        },
        {
            path: '/sqcg/:did',
            name: 'sqcg',
            meta: {
                title: '授权成功'
            },
            component: () => import('./views/success/emp.vue')
        },
    ]
})